import { MILE_TYPES } from "../TariffPlans/mileTypes";

/**
 * Разбор общего списка правил (nsi.partner_discount) в настройки одного клиента.
 *
 * Ручка отдаёт строку на плечо и правила всех субъектов сразу — партнёрские и
 * клиентские. Карточке нужен один клиент и все четыре его плеча, в том числе
 * ненастроенные: иначе поле формы было бы то undefined, то объект.
 *
 * Вынесено из компонента, чтобы правило проверялось тестом, не поднимая экран.
 */
export const emptyMiles = () =>
    MILE_TYPES.reduce((acc, { value }) => {
        acc[value] = { percent: null, tariffPlanId: null };
        return acc;
    }, {});

const clientRows = (list, clientGuid) =>
    (list ?? []).filter(
        (row) => row.subjectType === "CLIENT" && row.clientGuid === clientGuid
    );

export const milesOf = (list, clientGuid) => {
    const miles = emptyMiles();
    clientRows(list, clientGuid).forEach((row) => {
        if (!row.mileType || !(row.mileType in miles)) return;
        miles[row.mileType] = {
            percent: row.percent ?? null,
            tariffPlanId: row.tariffPlanId ?? null,
        };
    });
    return miles;
};

/**
 * Признак принадлежит клиенту целиком: строки заводятся вместе, но рассинхрон в
 * базе возможен, и включённой считается включённая где угодно — так же, как на
 * экране партнёров.
 *
 * Настроек нет вовсе — считаем включённым: тумблер в этом случае неактивен, а
 * первое сохранение не должно молча уйти выключенным.
 */
export const isActive = (list, clientGuid) => {
    const rows = clientRows(list, clientGuid);
    return rows.length === 0 || rows.some((row) => Boolean(row.active));
};

/**
 * Комплект тарифных карт клиента (расчёт v2) из общего списка назначений —
 * один на клиента; null — комплекта нет.
 */
export const tariffSetOf = (sets, clientGuid) => {
    const row = (sets ?? []).find(
        (set) => set.subjectType === "CLIENT" && set.clientGuid === clientGuid
    );
    return row ? { tariffSetId: row.tariffPlanId ?? null, active: Boolean(row.active) } : null;
};
